// src/app/core/themes/aira.preset.ts
import { definePreset } from '@primeuix/themes';
import Aura from '@primeuix/themes/aura';

/**
 * Preset PrimeNG — paleta corporativa Transmaritime
 *
 * Colores principales:
 * - Primary: #000C52 (Blue)
 * - Secondary: #004ADD (Blue)
 * - Tertiary: #7D6D37 (Gold)
 * - Accent: #FF9601 (Orange)
 * - Warning: #FABF2D (Yellow Mustard)
 * - Sky: #46A7FF (Blue Sky)
 */
export const AiraPreset = definePreset(Aura, {
  semantic: {
    primary: {
      50: '#e8e9f2',
      100: '#d1d3e5',
      200: '#a3a7cb',
      300: '#757bb1',
      400: '#474f97',
      500: '#19277d',
      600: '#141f6a',
      700: '#0f1757',
      800: '#000C52',
      900: '#00093d',
      950: '#000628',
    },
    secondary: {
      50: '#e6efff',
      100: '#ccdfff',
      200: '#99bfff',
      300: '#669fff',
      400: '#337fff',
      500: '#004ADD',
      600: '#003bb8',
      700: '#002c8a',
      800: '#001d5c',
      900: '#000f2e',
      950: '#000817',
    },
    tertiary: {
      50: '#f5f3ed',
      100: '#ebe7db',
      200: '#d7cfb7',
      300: '#c3b793',
      400: '#af9f6f',
      500: '#9b874b',
      600: '#7D6D37',
      700: '#64572c',
      800: '#4b4121',
      900: '#322b16',
      950: '#19150b',
    },
    accent: {
      50: '#fff8eb',
      100: '#fff1d6',
      200: '#ffe3ad',
      300: '#ffd585',
      400: '#ffc75c',
      500: '#ffb933',
      600: '#FF9601',
      700: '#cc7801',
      800: '#995a01',
      900: '#663c00',
      950: '#331e00',
    },
    warning: {
      50: '#fffbeb',
      100: '#fef6d7',
      200: '#fdedaf',
      300: '#fce487',
      400: '#fbdb5f',
      500: '#FABF2D',
      600: '#e5a812',
      700: '#b3830e',
      800: '#805e0a',
      900: '#4d3906',
      950: '#261d03',
    },
    colorScheme: {
      light: {
        primary: {
          color: '#000C52',
          inverseColor: '#ffffff',
          hoverColor: '#004ADD',
          activeColor: '#0f1757',
        },
        secondary: {
          color: '#004ADD',
          inverseColor: '#ffffff',
          hoverColor: '#003bb8',
          activeColor: '#46A7FF',
        },
        tertiary: {
          color: '#7D6D37',
          inverseColor: '#ffffff',
          hoverColor: '#64572c',
          activeColor: '#af9f6f',
        },
        accent: {
          color: '#FF9601',
          inverseColor: '#000000',
          hoverColor: '#cc7801',
          activeColor: '#ffc75c',
        },
        warning: {
          color: '#FABF2D',
          inverseColor: '#000000',
          hoverColor: '#e5a812',
          activeColor: '#FFD700',
        },
        highlight: {
          background: '#e8e9f2',
          focusBackground: '#d1d3e5',
          color: '#000C52',
          focusColor: '#004ADD',
        },
      },
      dark: {
        primary: {
          color: '#46A7FF',
          inverseColor: '#000C52',
          hoverColor: '#004ADD',
          activeColor: '#000628',
        },
        secondary: {
          color: '#46A7FF',
          inverseColor: '#004ADD',
          hoverColor: '#003bb8',
          activeColor: '#002c8a',
        },
        tertiary: {
          color: '#af9f6f',
          inverseColor: '#7D6D37',
          hoverColor: '#64572c',
          activeColor: '#4b4121',
        },
        accent: {
          color: '#ffc75c',
          inverseColor: '#FF9601',
          hoverColor: '#cc7801',
          activeColor: '#995a01',
        },
        warning: {
          color: '#FFD700',
          inverseColor: '#FABF2D',
          hoverColor: '#e5a812',
          activeColor: '#b3830e',
        },
        highlight: {
          background: 'rgba(0, 12, 82, 0.24)',
          focusBackground: 'rgba(0, 12, 82, 0.36)',
          color: '#e8e9f2',
          focusColor: '#46A7FF',
        },
      },
    },
  },
});
